export enum VideoHintPlayer {
  YOUTUBE = 'youtube',
  CLOUDFRONT = 'cloudfront'
}
